import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_ROUTE,
  mode: 'history',
  // linkActiveClass: 'uk-active',
  linkExactActiveClass: 'uk-active',

  routes: [{
    path: '/',
    name: 'Welcome',
    component: () => import(/* webpackChunkName: "welcome" */ '@/components/_pages/Welcome')
  }, {
    path: '/guide',
    name: 'Guide',
    component: () => import(/* webpackChunkName: "guide" */ '@/components/_pages/Guide')
  }, {
    path: '/tool',
    name: 'Tool',
    component: () => import(/* webpackChunkName: "tool" */ '@/components/_pages/Tool')
  }, {
    path: '/terms',
    name: 'Terms',
    component: () => import(/* webpackChunkName: "terms" */ '@/components/_pages/Terms')
  }, {
    path: '/reports',
    name: 'Reports',
    component: () => import(/* webpackChunkName: "reports" */ '@/components/_pages/Reports'),
    meta: {
      adminOnly: true
    }
  }, /* {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" *      / '@/components/_pages/Admin'),
    meta: {
      adminOnly: true
    }
  }, */{
    path: '*',
    redirect: '/'
  }],

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // close offcanvas if visible
  const offcanvas = uikit.offcanvas('#offcanvas')

  if (offcanvas && offcanvas.isToggled()) {
    offcanvas.hide()
  }

  // check for special conditions
  // administration page for instance, allowed only to admin users
  // https://router.vuejs.org/guide/advanced/meta.html

  // it might not be the best way to access the store, but it works for now
  const store = this.a.app.$store

  // if admin status required & not present -> just redirect to home (like any other non-existing pages)
  // store getter userIsAdmin enforces a silent server check as well
  if (to.matched.some(record => record.meta.adminOnly) && !store.getters.userIsAdmin) {
    next('/')
  } else {
    // inject page locale
    const page = to.name
    const locale = this.a.app.$i18n.locale

    import(`@/locale/_pages/${page}/${locale}.json`)
      .then(messages => {
        store.commit('setPageLocaleMessages', { page, locale, messages })
      })

    next()
  }
})

// push it here in order to be accessible under store functions (silent user check if admin move away)
Vue.router = router

export default router



// WEBPACK FOOTER //
// ./src/router/index.js